import {
  CREATE_SERVICE_REQUEST,
  UPDATE_SERVICE_REQUEST,
  DELETE_SERVICE_REQUEST,
} from "./types";

export const createServiceRequest = (payload, onSucess) => ({
  type: CREATE_SERVICE_REQUEST,
  payload,
  onSucess
});

export const updateServiceRequest = (payload, onSucess) => ({
  type: UPDATE_SERVICE_REQUEST,
  payload,
  onSucess
});


export const deleteServiceRequest = (payload, onSucess) => ({
  type: DELETE_SERVICE_REQUEST,
  payload,
  onSucess
});
